export enum FilterItemType {
	STUDIO = 'studioFilter',
	ANALYZE = 'analyzeFilter',
	FOLDER = 'filterFolder'
}